const doc = [({"da":({"js":({"admin":({"contacts":({"edit":({"organization_content":({"basic_information":"Grundoplysninger"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;